import React from 'react';
import './footer.scss';
import Google from '../../assets/google-download.png';
import Apple from '../../assets/apple-download.png';
import Playstore from './playstore.svg';
import Logo from '../navbar/wehaulogo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
    return ( 
        <div className="footer">
            <div className="content">
                <img className="logo" src={Logo} alt="wehaullogo" />
                <div className="links">
                    <ul>
                        <li className="titlex">Product</li>
                        <li>Request Delivery</li>
                        <li>Enterprise</li>
                        <li>Merchant</li>
                    </ul>
                    <ul>
                        <li className="titlex">Support</li>
                        <li>Contact us</li>
                        {/* <li>FAQ</li> */}
                    </ul>
                    <ul>
                        <li className="titlex">Company</li>
                        <li>About us</li>
                        <Link style={{textDecoration: "none", color: "#292929"}} to="/privacy_policy"><li>Privacy policy</li></Link>
                        <li>Terms and conditions</li>
                    </ul>
                </div>
                <div className="socials">
                   <p className="any">Any Questions ?</p>
                   <a href="mailto:hello@wehaul247.com" className="mail">hello@wehaul247.com</a>
                   <p className="xtra">Feel free! We speak human language <br /> and like to receive feedback.</p>
                   <div className="icons">
                       <i className="fab tmp fa-instagram"></i>
                       <i className="fab tmp fa-twitter"></i>
                       <i className="fab tmp fa-facebook-square"></i>
                   </div>
                </div>
            </div>
            <br />
            <div className="imgs">
                <a href="http://play.google.com/store/apps/details?id=com.wehaul.customer" target="_blank" rel="noopener noreferrer"><div style={{marginRight: "50px", backgroundImage: `url(${Google})`, transform: "scale(1.4)"}} className="imgx"></div></a>
                <a href="https://apps.apple.com/ng/app/wehaul/id1618324644" target="_blank" rel="noopener noreferrer"><div style={{backgroundImage: `url(${Apple})`, transform: "scale(1.4)"}} className="imgx"></div></a>
            </div>
        </div>
     );
}
 
export default Footer;